import type { LoadResource } from "@prequel/import-react";
import { useListLoads } from "@prequel/import-react";

import ResourceTable from "@/components/ResourceTable";
import Timestamp from "@/components/Timestamp";
import { useStreamContext } from "@/pages/import/StreamsPage/StreamPage";

const COLUMNS = ["Submitted", "Started", "Ended", "Processed", "Transformed", "Valid", "Loaded", "Errored"];

const formatCount = (value: number | null | undefined) => value?.toLocaleString() ?? "-";

const LoadsTable = () => {
  const { stream } = useStreamContext();
  const streamId = stream.id;

  const useLoads = (params: { pageSize?: number }) => useListLoads(streamId, params);

  const rowMapper = (load: LoadResource) => ({
    id: load.id,
    to: `/import/streams/${streamId}/loads/${load.id}`,
    cells: [
      { value: <Timestamp timestamp={load.submitted_at} /> },
      { value: load.started_at ? <Timestamp timestamp={load.started_at} /> : "-" },
      { value: load.ended_at ? <Timestamp timestamp={load.ended_at} /> : "-" },
      { value: formatCount(load.records_processed) },
      { value: formatCount(load.records_transformed) },
      { value: formatCount(load.records_valid) },
      { value: formatCount(load.records_loaded) },
      { value: formatCount(load.records_errored) },
    ],
  });

  return (
    <ResourceTable<LoadResource>
      columns={COLUMNS}
      useQuery={useLoads}
      rowMapper={rowMapper}
      emptyMessage="No loads found for this stream."
    />
  );
};

export default LoadsTable;
